module.exports = function(x) {
  return x * 2;
}



//////////////////
// WEBPACK FOOTER
// ./times2.js
// module id = 1
// module chunks = 0